exports = module.exports = require("../../../../../../css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".dv-decoration-1{width:100%;height:100%}.dv-decoration-1 svg{transform-origin:left top}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./~/@jiaminghi/data-view/lib/components/decoration1/src/main.css
// module id = 1087
// module chunks = 45